module.exports = __webpack_public_path__ + "static/media/27_tn.020f159e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/27_tn.jpg
// module id = 515
// module chunks = 0